import React from 'react';
import {useHistory} from 'react-router-dom';
import Styled from 'styled-components';
import {isClientUser} from '../../../shared/util/PermissionsUtil';

const SowButton = Styled.button`
	display: inline-flex;
	align-items: center;
	gap: 5px;
	font-size: 12px;
	font-weight: 600;
	color: #6e0fea;
	background: #f3eeff;
	border: 1px solid #c9b0ff;
	border-radius: 20px;
	padding: 4px 12px;
	cursor: pointer;
	margin-left: 10px;
	white-space: nowrap;
	line-height: 1.4;
	text-decoration: none;
	transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
	&:hover {
		background: #ead9ff;
		border-color: #a07de0;
		box-shadow: 0 1px 4px rgba(110, 15, 234, 0.15);
		color: #5a0cc8;
	}
	&:active {
		background: #dcc8ff;
	}
`;

interface Props {
	companyProjectId: number | undefined;
}

const NovaTranscriptLink: React.FC<Props> = ({companyProjectId}) => {
	const history = useHistory();

	const isOnTranscriptPage = history.location.pathname.endsWith('/transcript');

	if (!companyProjectId || isClientUser() || isOnTranscriptPage) return null;

	return (
		<SowButton onClick={() => history.push(`/project/P${companyProjectId}/transcript`)}>
			<svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M13 2H3C2.45 2 2 2.45 2 3v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-1 9H4v-1.5h8V11zm0-3H4V6.5h8V8zm0-3H4V3.5h8V5z"
					fill="currentColor"
				/>
			</svg>
			View AI Analysis
		</SowButton>
	);
};

export default NovaTranscriptLink;
